
export enum ApplicationStatus {
  NEW = 'New',
  WELCOME_SENT = 'Welcome Sent',
  SIGNED_ONBOARDED = 'Signed/Onboarded',
  ARCHIVED = 'Archived'
}

export interface User {
  id: string;
  name: string;
  email: string;
  password: string;
  role: 'admin' | 'editor';
}

export interface Referral {
  id: string;
  leadName: string;
  ambassadorCode: string;
  stage: 'QuizTaken' | 'Showed' | 'Matched' | 'Unknown';
  quizDate?: string;
  screenedDate?: string;
  matchedDate?: string;
  rawFields: Record<string, any>;
}

export interface Ambassador {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
  location: string; 
  phone: string;
  onboardingScore: number;
  status: ApplicationStatus;
  appliedDate: string;
  reason: string;
  typeformUrl: string;
  instagramHandle?: string;
  tiktokHandle?: string;
  previousExperience?: string;
  portfolioUrl?: string;
  profilePhotoUrl?: string;
  airtableId?: string;
  ambassadorCode?: string;
  password?: string; // New: persisted generated password
  shortLink?: string;
  address?: {
    street?: string;
    city?: string;
    state?: string;
    zip?: string;
    country?: string;
  };
  additionalFields: Array<{ label: string; value: string }>;
}

export interface SyncLog {
  timestamp: string;
  message: string;
  type: 'info' | 'success' | 'error';
}

export interface PersistentLog {
  id?: number;
  timestamp: string;
  message: string;
  type: string;
  details?: string;
}

export interface AppSettings {
  typeformToken: string;
  formId: string;
  corsProxy: string;
  ghlToken: string;
  ghlLocationId: string;
  ghlAmbassadorCodeFieldId: string;
  ghlAmbassadorPasswordFieldId: string;
  shopifyUrl: string;
  shopifyAccessToken: string;
  workerUrl: string;
  workerSecret: string;
  // Airtable Config
  airtableApiKey: string;
  airtableBaseId: string;
  atReferralTableId: string;
  atAmbassadorTableId: string;
}
